import SimpleBIConfig from "../Config"
export default class Config {
    //Base & API
    static get BASE_URL() {return SimpleBIConfig.BASE_API_URL};
    static get BASE_API_URL() {return this.BASE_URL + '/api/1.0/'};
    static get AUTH_API_URL() {return this.BASE_API_URL+ 'auth/token/'};
    static get AUTH_REFRESH_API_URL() {return this.BASE_API_URL+ 'auth/token/refresh/'};

    //User
    static get USER_API_URL() {return this.BASE_API_URL+"user/"};
    static get FORGOTPASS_API_URL() {return this.USER_API_URL + "forgotPassword/"};
    static get RESETPASS_API_URL() {return this.USER_API_URL + "resetPassword/"};
    static get VALIDATE_ACCOUNT_API_URL() {return this.USER_API_URL + "validate/"};
    static get WHOAMI_API_URL() {return this.USER_API_URL + "whoami/"};
    static get LOGOUT_API_URL() {return this.USER_API_URL + "logout/"};

    //Config
    static get API_URL_LANGUAGE () {return this.BASE_API_URL+"config_languages/"};
    static get API_URL_CONFIG () {return this.BASE_API_URL+"config/"};
    static get API_URL_CONFIG_FRONT () {return this.API_URL_CONFIG+"getConfigFront/"};
    static get API_URL_CONFIG_IDENTITY_TEXT () {return this.BASE_API_URL+"config_identityText/"};
    static get API_URL_CONFIG_IDENTITY_IMAGE () {return this.BASE_API_URL+"config_identityImage/"};
    // static get API_URL_CONFIG_MOBILEAPP () {return this.BASE_API_URL+"config_mobileApp/"};
    static get API_URL_CONFIG_WEBSITE () {return this.BASE_API_URL+"config_website/"};
    static get API_URL_CONFIG_MOBILEAPP_TEXT () {return this.BASE_API_URL+"config_mapp_text/"};
    static get API_URL_CONFIG_MOBILEAPP_IMAGE () {return this.BASE_API_URL+"config_mapp_image/"};

    //Reports
    static get API_URL_REPORTS() {return this.BASE_API_URL+"reports/"};
    static get API_URL_REPORTS_DEMOGRAPHIC() {return this.API_URL_REPORTS+"demographic/"};
    static get API_URL_REPORTS_GEOGRAPHIC() {return this.API_URL_REPORTS+"geographic/"};
    static get API_URL_REPORTS_PRODUCTS() {return this.API_URL_REPORTS+"products/"};
    static get API_URL_REPORTS_CLIENTS() {return this.API_URL_REPORTS+"clients/"};
    static get API_URL_REPORTS_FINANCIAL_SALES() {return this.API_URL_REPORTS+"financial_sales/"};
    static get API_URL_REPORTS_FINANCIAL_SALES_POST() {return this.API_URL_REPORTS+"financial_sales_post/"};
    static get API_URL_REPORTS_V2() {return this.BASE_API_URL+"reports-v2/"};
    static get API_URL_REPORTS_V2_SALES() {return this.API_URL_REPORTS_V2+"sales/"};
    static get API_URL_REPORTS_V2_ORDERS() {return this.API_URL_REPORTS_V2+"orders/"};
    static get API_URL_REPORTS_V2_LOCATIONS() {return this.API_URL_REPORTS_V2+"locations/"};
    static get API_URL_REPORTS_V2_LOCATIONS_LIST() {return this.API_URL_REPORTS_V2_LOCATIONS+"list/"};
    static get API_URL_REPORTS_SALES_TARGET() {return this.BASE_API_URL+"salesTarget/"};
    static get API_URL_REPORTS_TRANSACTIONS() {return this.BASE_API_URL+"inventoryTransaction/"};
    static get API_URL_INVENTORY_CHECK() {return this.BASE_API_URL+"inventoryCheck/"};
    static get API_URL_PRODUCT () {return this.BASE_API_URL+"product/"};

    static get API_URL_PURCHASE_ORDERS() {return this.BASE_API_URL+"purchaseOrders/"};
    static get API_URL_PURCHASE_ORDER_RECOMMENDATIONS() {return this.BASE_API_URL+"purchaseOrderRecommendations/"};
    static get API_URL_PURCHASE_ORDER_RECOMMENDATION_FILTERS() {return this.API_URL_PURCHASE_ORDER_RECOMMENDATIONS+"filters/"};
    static get API_URL_PRODUCT_SUPPLIER_INFO () {return this.BASE_API_URL+"productsupplierinfo/"};
    static get API_URL_CONFIG_SALESAPP () {return this.BASE_API_URL+"config_salesApp/"};

    static get API_URL_ORDERS () {return this.BASE_API_URL+"orders/"};
    static get API_URL_ORDERS_FEEDBACK () {return this.API_URL_ORDERS+"list_feedback/"};
    static get API_URL_ORDERS_FEEDBACK_SUMMARY () {return this.API_URL_ORDERS+"feedback_summary/"};
}
